import { render, staticRenderFns } from "./AreasOfConcernList.vue?vue&type=template&id=07fb2fbc&"
import script from "./AreasOfConcernList.vue?vue&type=script&lang=js&"
export * from "./AreasOfConcernList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports